import React from "react";

const IconPlus = () => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.49371 17C7.55969 17 6.80251 16.2428 6.80251 15.3088V1.6912C6.80251 0.757176 7.55969 0 8.49371 0C9.42774 0 10.1849 0.757176 10.1849 1.6912V15.3088C10.1849 16.2428 9.42774 17 8.49371 17ZM1.6912 10.1849C0.757174 10.1849 0 9.42774 0 8.49371C0 7.55969 0.757175 6.80252 1.6912 6.80252H15.3088C16.2428 6.80252 17 7.55969 17 8.49371C17 9.42774 16.2428 10.1849 15.3088 10.1849H1.6912Z" fill="#6446C3"/>
        </svg>
    )
}

export default IconPlus